import { useEffect, useState } from "react";

declare global {
  interface Window {
    tp: any;
  }
}

export const getBreakfastRsvpList = async (): Promise<string[]> => {
  return await new Promise((resolve, _reject) => {
    if (typeof window !== "undefined") {
      window.tp = window.tp || [];
      window.tp.push([
        "init",
        function () {
          window.tp.userId.loadExtendedUser({
            extendedUserLoaded: function (data) {
              const rsvpList =
                data.custom_field_values
                  ?.filter((field) => field.field_name === "breakfastRsvp")[0]
                  ?.value?.split(";") || [];

              resolve(rsvpList);
            },
            formName: "breakfastrsvp",
          });
        },
      ]);
    }
  });
};

const hasRsvped =
  (rsvpList: string[]) =>
  (id: string | number): boolean => {
    if (typeof id === "number") {
      id = id.toString();
    }

    return rsvpList.includes(id);
  };

const useBreakfastsRsvp = (): {
  isReady: boolean;
  rsvpList: string[] | null;
  hasRsvped: (id: string | number | null) => boolean;
} => {
  const [rsvpList, setRsvpList] = useState<string[] | null>(null);

  useEffect(() => {
    getBreakfastRsvpList().then(setRsvpList);
  }, []);

  return {
    isReady: rsvpList !== null,
    rsvpList,
    hasRsvped: hasRsvped(rsvpList || []),
  };
};

export default useBreakfastsRsvp;
